import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { PureComponent } from 'react';
// eslint-disable-next-line @repo/internal/react/no-class-components
var HtmlContent = /*#__PURE__*/function (_PureComponent) {
  _inherits(HtmlContent, _PureComponent);
  var _super = _createSuper(HtmlContent);
  function HtmlContent() {
    _classCallCheck(this, HtmlContent);
    return _super.apply(this, arguments);
  }
  _createClass(HtmlContent, [{
    key: "render",
    value: function render() {
      var html = this.props.html;
      return /*#__PURE__*/React.createElement("div", {
        dangerouslySetInnerHTML: {
          __html: html
        }
      });
    }
  }]);
  return HtmlContent;
}(PureComponent);
export { HtmlContent as default };